import axios from 'axios'
import React, { useCallback, useContext, useEffect, useState } from 'react'
import { message } from 'antd';
import { useNavigate } from 'react-router-dom';

interface UserInfo {
  adminAccount: string
  adminToken?: string | null
  adminUserID: string
  imToken?: string | null
  imUserID: string
  nickname: string
}
interface UserContextProps {
  user: UserInfo | null
  updateUser: (user: UserInfo | null) => void
  deviceToken?: string
  getLogin: (payload: any) => void
}
let axiosInstance = axios.create({
  baseURL: 'https://e-chat.mongol.net/complete_admin',
  timeout: 5000,
  headers: { 'Content-Type': 'application/json', 'operationID': '1001' },
})
// @ts-ignore
const UserContext = React.createContext<UserContextProps>(null)

export const useUserContext = (): UserContextProps => {
  return useContext(UserContext)
}

export function UserProvider({ children }: any) {

  const [loading, setLoading] = useState(false)
  const [user, updateUser] = useState<UserInfo | null>(null)
  const [messageApi, contextHolder] = message.useMessage();

  const navigate = useNavigate();



  useEffect(() => {
    getUserInfo()
  }, [])

  const getLogin = useCallback(async (payload: any) => {
    try {
      setLoading(true);

      const res = await axiosInstance.post('/account/login', payload);
      const result = res?.data?.data
      setLoading(false);

      axiosInstance = axios.create({
        baseURL: 'https://e-chat.mongol.net/complete_admin',
        timeout: 5000,
        // withCredentials: true,
        headers: { 'Content-Type': 'application/json', 'operationID': '1001' },
      })
      localStorage.setItem('token', result.adminToken)
      localStorage.setItem('imToken', result.imToken)
      updateUser({
        ...user,
        adminAccount: result?.adminAccount,
        adminToken: result?.adminToken,
        adminUserID: result?.adminUserID,
        imToken: result?.imToken,
        imUserID: result?.imUserID,
        nickname: result?.nickname
      })

      messageApi.open({
        type: 'success',
        content: 'Амжилттай нэвтэрлээ',
      });
      navigate('/dashboard')

    } catch (error: any) {
      messageApi.open({
        type: 'error',
        content: `Алдаа ${error.message}`,
      });
      updateUser(null);
      setLoading(false);
    }
  }, [axiosInstance]);

  const getUserInfo = async () => {
    const token = localStorage.getItem('token');
    if (token) {
      const newAxios = axios.create({
        baseURL: 'https://e-chat.mongol.net/complete_admin',
        timeout: 5000,
        // withCredentials: true,
        headers: { 'Content-Type': 'application/json', 'token': token },
      });
      axiosInstance = (newAxios);
      try {
        const res = await newAxios.post('/account/info', {}, {
          headers: { 'operationID': 'sdfsd' },
        })
        // console.log("🚀 ~ getUserInfo ~ res:"co, res)
        updateUser({

          adminToken: token,
          adminUserID: res?.data?.data?.userID,
          imToken: 'string',
          imUserID: res?.data?.data?.userID,
          adminAccount: res?.data?.data?.nickname,
          nickname: res?.data?.data?.nickname,
        })
      } catch (e: any) {
        messageApi.open({
          type: 'error',
          content: `Алдаа ${e.message}`,
        });
      }
    }



  }



  return <> {contextHolder} {loading ? <p>loading...</p> : <UserContext.Provider value={{ user, updateUser, getLogin }}>{children}</UserContext.Provider>}</>
}